<script>
const label = [
  {
    "value": null,
    "label": "NOI系列赛事",
    "children": [
      {
        "value": 1,
        "label": "CSP-J入门级"
      },
      {
        "value": 2,
        "label": "CSP-S提高级"
      },
      {
        "value": 3,
        "label": "NOIP 普及组"
      },
      {
        "value": 4,
        "label": "NOIP 提高组"
      },
      {
        "value": 5,
        "label": "NOIP"
      },
      {
        "value": 6,
        "label": "各省省选"
      },
      {
        "value": 7,
        "label": "NOI 国赛"
      }
    ]
  },
  {
    "value": null,
    "label": "蓝桥杯",
    "children": [
      {
        "value": 9,
        "label": "蓝桥杯青少赛"
      },
      {
        "value": 10,
        "label": "蓝桥杯省赛"
      },
      {
        "value": 11,
        "label": "蓝桥杯国赛"
      }
    ]
  },
  {
    "value": null,
    "label": "其他赛考",
    "children": [
      {
        "value": 12,
        "label": "CodeForces"
      },
      {
        "value": 13,
        "label": "USACO"
      },
      {
        "value": 14,
        "label": "Atcoder"
      }
    ]
  }
]

export default {
  label
}
</script>
